import React, { useContext } from 'react'
import { When } from 'react-if'
import { UNITED_STATES } from '@/constants/regions'
import { ProjectMetaContext } from '@/contexts/ProjectMetaContext/ProjectMetaContext'
import { useGetTheatricalReleaseBySlug } from '@/services/ProjectsService'
import { useUserRegion } from '@/services/UserRegionService'
import { mapTheatricalReleaseCriticToRating } from '@/views/WatchTheatricalView/Reviews'
import { RatingItem } from './RatingItem'

export const RatingsSection = () => {
  const { project } = useContext(ProjectMetaContext)
  const { region } = useUserRegion()
  const { theatricalRelease } = useGetTheatricalReleaseBySlug({
    theatricalSlug: project?.slug,
    region: region || UNITED_STATES,
    projectType: project?.projectType,
  })

  const theatricalReleaseTomatometer = theatricalRelease?.critics?.[0]?.scores?.find(
    (score) => score?.name?.toLowerCase() === 'tomatometer',
  )
  const theatricalReleaseAudience = theatricalRelease?.critics?.[0]?.scores?.find(
    (score) => score?.name?.toLowerCase() === 'audience',
  )
  const certifiedFresh = Boolean(theatricalRelease?.critics?.[0]?.certifiedFresh)
  const verifiedHot = Boolean(theatricalRelease?.critics?.[0]?.verifiedHot)

  const { rottenTomatoes, audience, cinema, imdb } = project || {}

  const rottenTomatoesRating =
    rottenTomatoes ||
    (theatricalReleaseTomatometer &&
      mapTheatricalReleaseCriticToRating(theatricalReleaseTomatometer, certifiedFresh, verifiedHot))
  const audienceRating =
    audience ||
    (theatricalReleaseAudience &&
      mapTheatricalReleaseCriticToRating(theatricalReleaseAudience, certifiedFresh, verifiedHot))

  return (
    <section id="ratings" className="my-4 flex w-full flex-row items-center justify-center lg:justify-start">
      <When
        condition={
          !!rottenTomatoesRating && !!rottenTomatoesRating.rating && parseInt(rottenTomatoesRating.rating) >= 70
        }
      >
        <RatingItem
          icon={rottenTomatoesRating?.icon}
          rating={rottenTomatoesRating?.rating}
          author={rottenTomatoesRating?.author}
        />
      </When>
      <When condition={!!audienceRating && !!audienceRating.rating && parseInt(audienceRating.rating) >= 70}>
        <RatingItem icon={audienceRating?.icon} rating={audienceRating?.rating} author={audienceRating?.author} />
      </When>
      <When condition={Boolean(cinema)}>
        <RatingItem icon={cinema?.icon} rating={cinema?.rating} author={cinema?.author} />
      </When>
      <When condition={Boolean(imdb)}>
        <RatingItem icon={imdb?.icon} rating={imdb?.rating} author={imdb?.author} />
      </When>
    </section>
  )
}
